import { useState } from 'react';

interface CellLockIndicatorProps {
  userName: string;
  color: string;
}

export function CellLockIndicator({ userName, color }: CellLockIndicatorProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="relative inline-flex items-center"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span
        className="inline-block h-2.5 w-2.5 rounded-full"
        style={{ backgroundColor: color }}
      />
      {showTooltip && (
        <div className="absolute -top-7 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white shadow-lg">
          Editing: {userName}
        </div>
      )}
    </div>
  );
}
